// UC Santa Cruz's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from UCSC's
// official 2026-2027 General Catalog, Academic Programs, Bachelor's Degrees
// (catalog.ucsc.edu/en/current/general-catalog/academic-programs/
// bachelors-degrees/): one list, not split by division, so one group. Each line
// is a major and its degree (B.A., B.S., B.M.) as the catalog writes it;
// combined majors keep the catalog's own names. Minors, contiguous
// bachelor's/master's pathways and graduate degrees are left out. The one flag
// quotes UCSC's admissions FAQ (the college file's `faq` source) on Computer
// Science. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-santa-cruz",
    "read": "2026-09-30",
    "intro": "Every bachelor's degree in UC Santa Cruz's official 2026-2027 General Catalog, with the degree it leads to. Minors, emphases and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's Degrees",
            "source": {
                "label": "UCSC General Catalog 2026-2027, Bachelor's Degrees",
                "url": "https://catalog.ucsc.edu/en/current/general-catalog/academic-programs/bachelors-degrees/"
            },
            "majors": [
                {
                    "name": "Agroecology",
                    "degree": "B.A."
                },
                {
                    "name": "Ancient Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Linguistics and Multilingualism",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Art & Design: Games + Playable Media",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biomolecular Engineering and Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.A."
                },
                {
                    "name": "Business Management Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.S."
                },
                {
                    "name": "Community Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A.",
                    "flag": "Space is limited. If you are offered your alternate major instead and accept it, you cannot switch to Computer Science later.",
                    "flagSource": "faq"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.",
                    "flag": "Space is limited. If you are offered your alternate major instead and accept it, you cannot switch to Computer Science later.",
                    "flagSource": "faq"
                },
                {
                    "name": "Computer Science: Computer Game Design",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Technologies",
                    "degree": "B.A."
                },
                {
                    "name": "Critical Race and Ethnic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Earth Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Earth Sciences/Anthropology Combined Major",
                    "degree": "B.A."
                },
                {
                    "name": "Ecology and Evolution",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics/Mathematics Combined",
                    "degree": "B.A."
                },
                {
                    "name": "Education, Democracy, and Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies/Biology Combined Major",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies/Earth Sciences Combined Major",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies/Economics Combined Major",
                    "degree": "B.A."
                },
                {
                    "name": "Feminist Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Digital Media",
                    "degree": "B.A."
                },
                {
                    "name": "Global and Community Health",
                    "degree": "B.A."
                },
                {
                    "name": "Global and Community Health",
                    "degree": "B.S."
                },
                {
                    "name": "Global Economics",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History of Art and Visual Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Language Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American and Latino Studies/Education, Democracy, and Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American and Latino Studies/Politics Combined",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American and Latino Studies/Sociology Combined",
                    "degree": "B.A."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics Theory and Computation",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular, Cell, and Developmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Network and Digital Technology",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics (Astrophysics)",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Plant Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Technology and Information Management",
                    "degree": "B.S."
                },
                {
                    "name": "Theater Arts",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
